import React from "react";
import { useSelector } from "react-redux";
import { t } from "i18next";
import { useLang } from "hooks";
import C from "Constants";
import DeliveryWaveOffWidget from "./DeliveryWaveOffWidget";
import { UTILS } from "utils";


const ItemsPaymentTotalDetail = (props) => {
  const { currentLang } = useLang();
  //global state
  const { discountInfo, isDiscountApplied } = useSelector(
    (state) => state?.Discounts
  );
  const { loyaltyApplied, loyaltyAmount } = useSelector(
    (state) => state?.Loyalty
  );

  const {ordered} = useSelector(
      (state) => state.order
  );

  const { selectedTip } = useSelector((state) => state?.TipMethodsReducer);
  const { cart , discountAmount, amountAfterDiscount , totalOrdersGrossAmount, orderGrossAmount , itemsGrossAmount} = useSelector(
    (state) => state?.cart
  );
  const { orderType } = useSelector((state) => state?.AppReducer);
  const { original, deliveryFee, taxRate, children, userWallet } = props;
  const page = props.page === true ? true : false;

  const totalAmount = props?.page === "dine-in" ? totalOrdersGrossAmount:orderGrossAmount
  
  const PercentageType = (discount) => {
    const showDiscountValue = (value) => {
      const discount_Value = Number(value);
      if (discount_Value && discount_Value > 100) return 100;
      else return discount_Value;
    };
    const getPercentAmount = (value) => {
      const discount_Value = Number(value);
      const items_Total = Number(original);
      if (discount_Value && discount_Value > items_Total) return items_Total;
      return discount_Value;
    };

    return (
      <li className="pb-1 basket-item flex items-center flex-row justify-between flex-100 px-4 text-16x">
        <span className="item max-w-[50%]">
          <div className="">
            <span className="text-green-500">
              <span>{t("Discount")} </span>
              <span className=" text-10x block " style={{ fontSize: "10px" }}>
                {`(  
                  ${
                    currentLang === "AR"
                      ? `%${showDiscountValue(
                          discount?.dicount?.discountAmount
                        )}`
                      : `${showDiscountValue(
                          discount?.dicount?.discountAmount
                        )}% `
                  }
                
               
                
                ${t("AED")} ${
                  discount?.dicount?.isApplicableOnAllItems
                    ? t("all Items")
                    : t("Selected Items")
                }
             
                 ${
                   discount?.dicount?.maximumDiscountValue !== 0
                     ? `${t("Up to")} 
                     ${discount?.dicount?.maximumDiscountValue} 
                       ${t("AED")} `
                     : ""
                 }
              )`}
              </span>
            </span>
          </div>
        </span>
        <span className="text-green-500">
          <span> - </span>
          {currentLang === "AR"
            ? getPercentAmount(discountAmount) + " " + t("AED")
            : t("AED") + " " + getPercentAmount(discountAmount)}
        </span>
      </li>
    );
  };
  const FixedType = (discount) => {
    return (
      <li className="pb-1 basket-item flex items-center flex-row justify-between flex-100 px-4 text-16x">
        <span className="item item max-w-[50%]">
          <div className="">
            <span className="text-green-500">
              <span>{t("Discount")} </span>
              <span className="text-10x block" style={{ fontSize: "10px" }}>
                {`( ${discount?.dicount?.discountAmount} ${t("AED")} ${
                  discount?.dicount?.isApplicableOnAllItems
                    ? t("all Items")
                    : t("Selected Items")
                }
              )
              `}
              </span>
            </span>
          </div>
        </span>
        <span className="text-green-500">
          <span> - </span>

          {currentLang === "AR"
            ? discountAmount + " " + t("AED")
            : t("AED") + " " + discountAmount}
        </span>
      </li>
    );
  };

  return (
    <>
      {children ? <div className="mt-5">{children}</div> : null}
      <div
        className={`bg-white  pt-4 ${
          !props?.loyaltyPolicy?.isLoyaltyActive && props.page === "checkout"
            ? ""
            : "mt-5 border-t-4 border-gray-200"
        }`}
      >
        <DeliveryWaveOffWidget />
        <h4 className="text-outer-space text-17x font-semibold mx-4">
          {t("Payment summary")}
        </h4>
        <ul className="basket-contents__items pt-5 ">
          {((discountInfo && isDiscountApplied) ||
            (loyaltyApplied && userWallet > 0)) && (
            <li className=" pb-1 basket-item flex items-center flex-row  justify-between flex-100 px-4 text-16x">
              <span className="item">
                <div className="orderweb__09f2b375">
                  <span className="line-through text-black">
                    {t("Original Basket Total")}
                  </span>
                </div>
              </span>
              {original && (
                <span className="text-black line-through">
                  {currentLang === "AR"
                    ? original + " " + t("AED")
                    : t("AED") + " " + original}
                </span>
              )}
            </li>
          )}
          {discountInfo &&
            isDiscountApplied &&
            (discountInfo?.discountType === "percentage" ? (
              <PercentageType dicount={discountInfo} />
            ) : (
              <FixedType dicount={discountInfo} />
            ))}

          {loyaltyApplied && userWallet > 0 && (
            <li className="py-1 basket-item flex items-center flex-row justify-between flex-100 px-4 text-16x">
              <span className="item">
                <div className="orderweb">
                  <span className="text-green-500">{t("Loyalty points")} </span>
                </div>
              </span>
              <span className="text-green-500">
                <span> - </span>
                {currentLang === "AR"
                  ? loyaltyAmount.toFixed(2) + " " + t("AED")
                  : t("AED") + " " + loyaltyAmount.toFixed(2)}
              </span>
            </li>
          )}

          {cart.length > 0 && (
            <li className=" pb-1 basket-item flex items-center flex-row justify-between flex-100 px-4 text-16x">
              <span className="item">
                <div className="orderweb">
                  <span className="text-black">{t("Basket Total")} </span>
                </div>
              </span>
              {discountInfo && isDiscountApplied && amountAfterDiscount ? (
                <span className="text-black">
                  {currentLang === "AR"
                    ? amountAfterDiscount + " " + t("AED")
                    : t("AED") + " " + amountAfterDiscount}
                </span>
              ) : (
                <span className="text-black">
                  {currentLang === "AR"
                    ? amountAfterDiscount + " " + t("AED")
                    : t("AED") + " " + amountAfterDiscount}
                </span>
              )}
            </li>
          )}

          {ordered.orderesTotalItemsPrice > 0 && (
            <li className=" pb-1 basket-item flex items-center flex-row justify-between flex-100 px-4 text-16x">
              <span className="item">
                <div className="orderweb">
                  <span className="text-black">{t("Previous Total")} </span>
                </div>
              </span>
              {ordered.orderesTotalItemsPrice ? (
                <span className="text-black">
                  {currentLang === "AR"
                    ? ordered.orderesTotalItemsPrice + " " + t("AED")
                    : t("AED") + " " + ordered.orderesTotalItemsPrice}
                </span>
              ) : null}
            </li>
          )}

          {orderType?.EN?.name === C.SERVICE_TYPE.DELIVERY ? (
            <li className="pb-1 basket-item flex items-center flex-row justify-between flex-100 px-4 text-16x">
              <span className="item">
                <div className="orderweb__09f2b375">
                  <span className="text-black">{t("Delivery Fee")} </span>
                </div>
              </span>
              {deliveryFee && (
                <span className="text-black">
                  {currentLang === "AR"
                    ? deliveryFee + " " + t("AED")
                    : t("AED") + " " + deliveryFee}
                </span>
              )}
            </li>
          ) : null}

          {ordered.allOrders && ordered.allOrders.length > 0 && <li className="pb-0 basket-item flex items-center flex-row justify-between flex-100 px-4 text-16x">
            <span className="item">
              <div className="orderweb__09f2b375">
                <span className="text-black">{t("Previous-Added Tax")}{` (${taxRate}%)`}</span>
              </div>
            </span>
            
              <span className="text-black">{`AED ${(
                ordered.ordersTotalTax || 0.00
              ).toFixed(2)} `}</span>
            
          </li>}

          {ordered.allOrders && ordered.allOrders.length > 0 && ordered.totalTipAmount > 0 && <li className="pb-0 basket-item flex items-center flex-row justify-between flex-100 px-4 text-16x">
            <span className="item">
              <div className="orderweb__09f2b375">
                <span className="text-black">{t("Previous-Added Tip")}</span>
              </div>
            </span>
            
              <span className="text-black">{`AED ${(
                ordered.totalTipAmount || 0.00
              ).toFixed(2)} `}</span>
            
          </li>}

          {cart && cart.length > 0 && <li className="pb-0 basket-item flex items-center flex-row justify-between flex-100 px-4 text-16x">
            <span className="item">
              <div className="orderweb__09f2b375">
                <span className="text-black">{t("Value-Added Tax")}{` (${taxRate}%)`} </span>
              </div>
            </span>
              <span className="text-black">{`AED ${(
                itemsGrossAmount *
                (taxRate / 100)
              ).toFixed(2)} `}</span>
          </li>}
          
          

          {selectedTip && (
            <li className="pb-0 basket-item flex items-center flex-row justify-between flex-100 px-4 text-16x">
              <span className="item">
                <div className="orderweb__09f2b375">
                  <span className="text-black">{t("Tip")} {selectedTip.type === "default"
                    ? `(${(selectedTip.value * 100).toFixed(0)}%)`
                    : ''}</span>
                </div>
              </span>
              
                <span className="text-black">{`AED ${
                  selectedTip.type === "custom"
                    ? (selectedTip.value).toFixed(2)
                    : (itemsGrossAmount * selectedTip.value).toFixed(2)
                }`}</span>
            </li>
          )}


          {ordered?.splitPayed && ordered?.splitPayed > 0 ? (
            <li className="pb-0 basket-item flex items-center flex-row justify-between flex-100 px-4 text-16x">
              <span className="item">
                <div className="orderweb__09f2b375">
                  <span className="text-black">{t("Split Payed")} </span>
                </div>
              </span>
              
                <span className="text-black">{`AED ${ordered.splitPayed}`}</span>
            </li>
          ):null}
        </ul>
        <div className="py-0">
          <div className="py-4">
            <div className="flex items-center justify-between px-4 text-16x">
              <span className="flex items-center flex-auto px-.5">
                <span
                  className={
                    page
                      ? "text-outer-space text-22x font-semibold"
                      : "text-black text-17x font-bold"
                  }
                >
                  {t("Total")}
                </span>
              </span>

              <span className="text-16x">
                <span
                  className={
                    page
                      ? "text-outer-space text-22x"
                      : "text-black text-17x font-bold"
                  }
                >
                  {currentLang === "AR"
                    ? totalAmount.toFixed('2') + " " + t("AED")
                    : t("AED") + " " + totalAmount.toFixed('2')}
                </span>
              </span>
            </div>
          </div>

          {ordered?.splitPayed && ordered?.splitPayed > 0 ? (
            <li className="pb-0 basket-item flex items-center flex-row justify-between flex-100 px-4 text-16x">
              <span className="item">
                <div className="orderweb__09f2b375">
                  <span className="text-black text-17x font-bold">{t("Remaining Payment")} </span>
                </div>
              </span>
              
                <span className="text-black text-17x font-bold">{currentLang === "AR"
                    ? UTILS.roundToTwoDecimals(parseFloat(totalAmount.toFixed('2')) - parseFloat(ordered.splitPayed)) + " " + t("AED")
                    : t("AED") + " " + UTILS.roundToTwoDecimals(parseFloat(totalAmount.toFixed('2')) - parseFloat(ordered.splitPayed)) }</span>
            </li>
          ): null}


        </div>
      </div>
    </>
  );
};

export default ItemsPaymentTotalDetail;